<section class="container">
  <div class="table-responsive" *ngIf="modalidadesNoScr || modalidadesNoScr.length">
    <table class="table table-hover">
      <thead>
      <tr>
        <th id="col-codigo" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'codigoScrModalidade'"
            [nomeAtributoExibicao]="'Código'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-descricao-modalidade" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'nomeScrModalidade'"
            [nomeAtributoExibicao]="'Descrição Modalidade'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-tipo" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'tipoScrModalidade'"
            [nomeAtributoExibicao]="'Tipo'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-tipo-cliente" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'tipoCliente'"
            [nomeAtributoExibicao]="'Tipo Cliente'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-acoes" scope="col"class="text-center">          
          Ações
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of modalidadesNoScr">
        <td>{{ item.codigoScrModalidade }}</td>
        <td>{{ item.nomeScrModalidade }}</td>
        <td>{{ labelTipo(item?.tipoScrModalidade) }}</td>
        <td>{{ item?.tipoCliente }}</td>
        <td>
          <a href="javascript:void(0)" bnConfirm tituloConfirm="Confirmação"
              msgConfirm="Confirmar a exclusão do código de modalidade selecionado?" 
              (onConfirm)="confirmaExclusao(item.codigoScrModalidade)">
            <i class="fa fa-trash text-danger" ></i>                  
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</section>
